
export default {
  name: 'Default'
}
